<template>
  <div>
    <v-data-table
        dense
        :headers="getColumns"
        :items="itemList"
        item-key="id"
        class="elevation-1"
        :options.sync="options"
        @update:options="updateOptions"
        :server-items-length="totalRecords"
        :loading="loading"
        show-select
        v-model="selectedItemList"
        :footer-props="{
          'items-per-page-options': [10, 15, 20, 50, 100]
        }"
        :height="windowHeight"
        fixed-header
    >
      <template v-slot:top>
        <v-toolbar dense class="mt-2 pt-1 mb-2" elevation="1" color="gridtoolbar">
          <v-text-field
              dark
              v-model="searchTerm"
              label="Search"
              class="mx-4"
              clearable
              @input="onUpdateSearchTerm"
          ></v-text-field>
          <v-text-field
              dark
              v-model="searchTermFile"
              label="File search"
              class="mx-4"
              clearable
              @input="onUpdateSearchTerm"
          ></v-text-field>
          <v-switch v-model="onlyFailedView" label="only failed update" class="ml-5 mt-4"
                    color="deep-orange accent-2"
                    @change="onUpdateSearchTerm"></v-switch>
          <v-switch v-model="isAlive" label="not alive/alive" class="ml-5 mt-4"
                    @change="onUpdateSearchTerm"></v-switch>
          <v-switch v-model="briefView" label="brief view" class="ml-5 mt-4"></v-switch>
          <v-spacer></v-spacer>
          <v-btn
            small
            class="mt-n1"
            @click="$router.push({name: 'QuoteList_QuoteItem', params: {itemId: null}})"
          >
            Add
          </v-btn>
<!--          <router-link :to="{name: 'QuoteList_QuoteItem', params: {itemId: null}}">Add</router-link>-->
        </v-toolbar>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-container fluid>
          <v-row>
            <BaseTaskProgress v-model="item">
            </BaseTaskProgress>
            <v-spacer></v-spacer>
            <v-icon
                v-if="item.notion_id != null"
                color="primary"
                small
                @click="onNotion(item)"
            >
              mdi-alpha-n-box-outline
            </v-icon>
          </v-row>
        </v-container>
      </template>
      <template v-slot:item.variants_list="{item}">
        <p v-for="variant of item.variants_list" class="mb-0">
          {{ variant }}
        </p>
      </template>
      <template v-slot:item.editors_list="{item}">
        <p v-for="editor of item.editors_list" class="mb-0">
          {{ editor }}
        </p>
      </template>
      <template v-slot:item.title="{ item }">
        <router-link :to="{name:'QuoteList_QuoteItem', params: { itemId: item.id, searchTermFile: searchTermFile}}">{{ item.title }}</router-link>
      </template>
    </v-data-table>

    <v-toolbar flat dense v-if="isAlive">
        <v-btn
            color="primary"
            class="mr-4"
            @click="onSyncNotion"
            :loading="updateLoading"
            :disabled="!(selectedItemList.length > 0)"
        >
          Update selected
        </v-btn>
        <BaseDeleteDialog :disabled="!(selectedItemList.length > 0)" :loading="deleteLoading"
                          :onDeleteAction="onRemoveItems" title="Remove selected"></BaseDeleteDialog>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-toolbar flat dense v-else>
        <v-btn
            color="primary"
            class="mx-4"
            @click="onRestore"
            :loading="restoring"
            :disabled="!(selectedItemList.length > 0)"
        >
          Restore selected
        </v-btn>
      <v-spacer></v-spacer>
    </v-toolbar>
<!--    <BaseModal></BaseModal>-->
    <router-view></router-view>
  </div>
</template>

<script>
import {debounce} from "debounce"
import {mapGetters, mapActions} from 'vuex';
import {mapFields} from 'vuex-map-fields';
import BaseDeleteDialog from "@/components/BaseDeleteDialog";
import BaseTaskProgress from "@/components/BaseTaskProgress"
import BaseModal from "@/components/Base/BaseModal";

export default {
  name: 'QuoteList',
  props: {
    'subheight': {type: [Number], default: 200},
  },

  components: {
    BaseDeleteDialog,
    BaseTaskProgress,
    BaseModal,
  },

  computed: {
    ...mapGetters('Quote', ['getColumns']),
    ...mapFields('Quote', ['options', 'totalRecords', 'options.page', 'onlyFailedView', 'briefView', 'itemList',
      'loading', 'deleteLoading', 'updateLoading', 'restoring', 'selectedItemList', 'searchTermFile', 'searchTerm', 'isAlive']),
  },

  methods: {
    ...mapActions('Quote', ['openWebSocket', 'fetchItemList', 'fetchItem', 'fetchDeleteSelectedItem',
      'fetchSyncNotionSelectedItems', 'fetchRestoreSelectedItems']),
    onResize() {
      this.windowHeight = (window.innerHeight - this.subheight) + 'px'
    },
    onUpdateSearchTerm: debounce(function () {
      // console.log('onUpdateSearchTerm')
      this.options.page = 1
      this.fetchItemList()
    }, 800),

    updateOptions() {
      // console.log('updateOptions')
      this.fetchItemList()
    },

    onNotion(item) {
      // console.log('onNotion', item)
      window.open('https://www.notion.so/' + item.notion_id.replace(/-/g, ''), '_blank')
    },
    onSyncNotion() {
      // console.log('onSyncNotion')
      this.fetchSyncNotionSelectedItems();
    },
    onRestore() {
      // console.log('onRestore')
      this.fetchRestoreSelectedItems();
    },
    onRemoveItems() {
      this.fetchDeleteSelectedItem()
    },
  },

  async mounted() {
    // console.log('mounted')
    window.addEventListener("resize", this.onResize)
  },

  created() {
    window.addEventListener("resize", this.onResize);
  },
  destroyed() {
    window.removeEventListener("resize", this.onResize);
  },

  data() {
    return {
      windowHeight: (window.innerHeight - this.subheight) + 'px',
    }
  }
}
</script>

<style scoped lang="scss">
</style>
